import { BASE_URL } from "./ServerEndpointController";
import axios from 'axios';

const PASSWORDS_ENDPOINT = `${BASE_URL}/passwords`;
export async function isProtected() {
    try {
        const response = await axios.get(`${PASSWORDS_ENDPOINT}/protected`);
        return response.data.protected;
    } catch (error) {
        console.error('Error checking protection status:', error);
        return true; 
    }
}

export async function login(password) {
    try {
        const response = await axios.post(`${PASSWORDS_ENDPOINT}/login`, { password });
        return {
            success: response.data.success,
            token: response.data.token,
        };
    } catch (error) {
        if (error.response) {
            throw error;
        } 
        console.error('Error logging in:', error);
        throw new Error('Network error. Please try again later.');
    }
}

export async function logout() {
    try {
        const response = await axios.post(`${PASSWORDS_ENDPOINT}/logout`);
        return response.data;
    } catch (error) {
        console.error('Error logging out:', error);
        throw error;
    }
}